/**
 * Auto-login utility for Console SSO integration
 * Security improvement: Only reads minimal data (token + googleId)
 * Full user data is fetched from Cognito using the googleId
 */

interface AutoLoginData {
  token: string;
  googleId: string;
}

/**
 * Check if URL contains auto-login parameters from Console
 * Security improvement: Only reads minimal data (token + googleId)
 * @returns AutoLoginData | null
 */
export const getAutoLoginData = (): AutoLoginData | null => {
  const params = new URLSearchParams(window.location.search);
  
  if (params.get('_autoLogin') !== 'true') {
    return null;
  }

  const token = params.get('_token');
  const googleId = params.get('_googleId');

  // Validate required fields
  if (!token || !googleId) {
    console.warn('🔐 Auto-login attempted but missing required fields (token, googleId)');
    return null;
  }

  return {
    token,
    googleId,
  };
};

/**
 * Clear auto-login parameters from URL
 * This removes sensitive data from browser history
 */
export const clearAutoLoginParams = (): void => {
  const url = new URL(window.location.href);
  
  // Remove all _autoLogin parameters
  url.searchParams.delete('_autoLogin');
  url.searchParams.delete('_token');
  url.searchParams.delete('_googleId');

  // Replace URL without reloading
  window.history.replaceState({}, '', url.toString());
  
  console.log('✅ Auto-login params cleared from URL');
};

/**
 * Save minimal auto-login data to localStorage
 * Full user data will be fetched from Cognito using getUserRole API
 */
export const saveAutoLoginData = (data: AutoLoginData): void => {
  // Save minimal data - full data will be fetched from Cognito
  localStorage.setItem('token', data.token);
  localStorage.setItem('googleId', data.googleId);

  console.log('✅ Minimal auto-login data saved (token + googleId)');
  console.log('ℹ️  Full user data will be fetched from Cognito');
};


